/* GULATIS theme — motion spine: Lenis smooth-scroll + GSAP scroll-reveals.
   Progressive enhancement; CSS handles the no-JS fallback. */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    // ---- Lenis smooth scroll (the "grand" scroll spine) ----
    if (window.Lenis && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var lenis = new Lenis({ duration: 1.1, easing: function (t){ return Math.min(1, 1.001 - Math.pow(2, -10 * t)); } });
      function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      if (window.gsap && window.ScrollTrigger) { lenis.on('scroll', ScrollTrigger.update); }
    }
    // ---- scroll reveals (data-reveal) ----
    var els = document.querySelectorAll('[data-reveal]');
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      els.forEach(function (el) {
        gsap.fromTo(el, { autoAlpha: 0, y: 28 }, {
          autoAlpha: 1, y: 0, duration: 0.9, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 86%' }
        });
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es){ es.forEach(function (e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.12 });
      els.forEach(function (el){ io.observe(el); });
    } else {
      els.forEach(function (el){ el.classList.add('is-in'); });
    }
  });
})();
